'use client'

import { SimplePDFDrawer } from '@/components/pdf/SimplePDFDrawer'
import { createContext, ReactNode, useContext, useState } from 'react'

interface PDFDrawerContextType {
  openPDFDrawer: (pagina?: string, documentName?: string, language?: string) => void
  closePDFDrawer: () => void
}

const PDFDrawerContext = createContext<PDFDrawerContextType | undefined>(undefined)

interface PDFDrawerProviderProps {
  children: ReactNode
}

/**
 * Provider per gestire lo stato del drawer PDF globalmente
 */
export function PDFDrawerProvider({ children }: PDFDrawerProviderProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [page, setPage] = useState('1')
  const [documentName, setDocumentName] = useState('Guida-dello-Studente-2025_2026.pdf')
  const [language, setLanguage] = useState('it')
  const openPDFDrawer = (
    pageParam?: string,
    documentNameParam?: string,
    languageParam?: string
  ) => {
    setPage(pageParam || '1')
    setDocumentName(documentNameParam || 'Guida-dello-Studente-2025_2026.pdf')
    setLanguage(languageParam || 'it')
    setIsOpen(true)
  }

  const closePDFDrawer = () => {
    setIsOpen(false)
  }

  return (
    <PDFDrawerContext.Provider value={{ openPDFDrawer, closePDFDrawer }}>
      {children}
      <SimplePDFDrawer
        isOpen={isOpen}
        onClose={closePDFDrawer}
        page={page}
        documentName={documentName}
        language={language}
      />
    </PDFDrawerContext.Provider>
  )
}

/**
 * Hook per utilizzare il context del drawer PDF
 */
export function usePDFDrawer() {
  const context = useContext(PDFDrawerContext)
  if (context === undefined) {
    throw new Error('usePDFDrawer must be used within a PDFDrawerProvider')
  }
  return context
}
